import { createFileRoute } from "@tanstack/react-router"
import { AddMessengerIntegration } from "modules/settings/components/integrations/messenger/AddMessengerIntegration"
import { MessengerAuthorizeSchema } from "schema"
import z from "zod"

export const Route = createFileRoute("/_base/_auth/settings/channels/messenger/new")({
  component: AddMessengerIntegration,
  validateSearch: (search: Partial<z.infer<typeof MessengerAuthorizeSchema>>) => {
    return MessengerAuthorizeSchema.parse(search)
  },
})
